import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoadingBar from 'react-top-loading-bar'
import { RootState } from "../../app/store";
import LoginForm from "../../components/LoginForm";
import { FormWraper } from "../Register/styles";
import Footer from '../../components/Footer';
import Alert from '../../components/AlertMessage'
import { clearLogState } from '../../features/loginSlice'
import { clearAddState } from '../../features/resetPasswordSlice'
import {
    Container,
    LoginContainer,
    LoginWrapper,
    LoginLogoWrapper,
} from './styles'
import { DailaiLogo, CommonContainer, CommonContentContainer } from '../../globalStyles';

function Login() {
    const { isLogSuccess, isLogFetching, errorLogMessage } = useSelector((state: RootState) => state.login)
    // Change Password store variable use to display successful change password operation
    const { isChangeSuccess } = useSelector((state: RootState) => state.changePassword)
    // Forgot password store variable use to display successful reset password operation
    const { isResetSuccess} = useSelector((state: RootState) => state.resetPassword)
    const showChangePasswordMessage = isChangeSuccess;
    const showForgotPasswordMessage = isResetSuccess;
    const [progress, setProgress] = useState<number>(0)
    let navigate = useNavigate()
    const dispatch = useDispatch()
    const token = localStorage.getItem('token')
    //console.log("isChangeSuccess: ", isChangeSuccess)
    useEffect(() => {
        if (isLogSuccess || token) {
            navigate('/userdashboard')
            dispatch(clearLogState())
            dispatch(clearAddState())
        }
    }, [isLogSuccess, navigate, dispatch, token])

    useEffect(() => {
        if (isLogFetching) {
            const handle = setInterval(() => {
                setProgress(progress => progress + 10)
                if (progress > 100) { return }
            }, 100);
            return () => clearInterval(handle);
        }
        setProgress(100)
    }, [isLogFetching, progress])



    return (
      <>
        <CommonContainer>
        <CommonContentContainer>
                    <Container>
                        {isLogFetching ? <LoadingBar
                            color='#f11946'
                            progress={progress}
                            onLoaderFinished={() => setProgress(0)}
                        /> : null}
                        <LoginContainer>
                            <LoginWrapper>
                                {errorLogMessage ?
                                    <Alert
                                        text={errorLogMessage}
                                        bgColor="#f8d7da"
                                        txtColor="#721c24"
                                    /> : null
                                }
                                {showChangePasswordMessage || showForgotPasswordMessage ?
                                    <Alert
                                      text={"Password successfully updated. Login using your new password."}
                                      bgColor={"#d4edda"}
                                      txtColor={"#155724"}
                                    /> : null
                                }
                                <LoginLogoWrapper>
                                    <DailaiLogo src="https://res.cloudinary.com/dba8ifej6/image/upload/v1644372534/dailai_auth_logo_ikt3gm.png" />
                                </LoginLogoWrapper>
                                <FormWraper>
                                    {/* <LoginTitle>{t('Login', language)}</LoginTitle> */}
                                    <LoginForm />
                                </FormWraper>
                            </LoginWrapper>
                        </LoginContainer>
                    </Container>


        </CommonContentContainer>
        </CommonContainer>
        <Footer />
      </>
    )
}

export default Login;
